import React, { useEffect, useContext } from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  useLocation,
  Navigate,
  useOutletContext,
} from 'react-router-dom'
import LoginScreen from '../pages/Login/Login'
import PrivateRoute from './PrivateRouter'
import TenantGuard from '../components/TenantGuard'
import PermissionGuard from '../components/PermissionGuard'
import AdminGuard from '../components/AdminGuard'
import Validation from '../pages/Login/Validation'
import CompleteRegister from '../pages/Login/CompleteRegister'
import SuccessMsg from '../pages/Login/SuccessMsg'
import AdminRegister from '../pages/Login/AdminRegister'
import ClientPanel from '../pages/ClientPanel'
import HomeScreen from '../pages/ClientPanel/Home'
import CertificatesContent from '../pages/ClientPanel/Certificates'
import StockContent from '../pages/ClientPanel/Stock'
import ProductionFlow from '../pages/ClientPanel/ProductionFlow'
import PeopleContent from '../pages/ClientPanel/Accesses'
import PeopleTableSwitch from '../pages/ClientPanel/Accesses/PeopleTableSwitch'

import ServicesTable from '../pages/ClientPanel/ProductionFlow/ServicesTable'
import PCPGrid from '../pages/ClientPanel/ProductionFlow/PCPGrid'
import StagesTable from '../pages/ClientPanel/ProductionFlow/StagesTable'
import CreateOPModal from '../components/Services/CreateServiceModal'
import AddOpInPcp from '../components/ModalWithoutColumns'
import StockTable from '../pages/ClientPanel/Stock/StockTable'
import MovementTable from '../pages/ClientPanel/Stock/MovementsTable'
import ProductionMovementTable from '../pages/ClientPanel/ProductionFlow/MovementTable'
import TableAccesses from '../pages/ClientPanel/Accesses/AccessesTable'
import TableProfile from '../pages/ClientPanel/Accesses/ProfilesTable'
import CompaniesContent from '../pages/ClientPanel/Companies'
import NotFoundPage from '../pages/SystemErrors/NotFound'
import CertificatesTable from '../pages/ClientPanel/Certificates/CertificateTable'
import CreateCertificate from '../pages/ClientPanel/Certificates/CreateCertificate'
import ParamTable from '../pages/ClientPanel/Certificates/ParamTable'
import CreateParam from '../pages/ClientPanel/Certificates/CreateParam'
import ViewCertificateModal from '../components/Certificates/ViewCertificateModal'
import MachinesTable from '../pages/ClientPanel/ProductionFlow/MachinesTable'
import EquipmentContent from '../pages/ClientPanel/Equipment'
import EquipmentTable from '../pages/ClientPanel/Equipment/Machines/EquipmentTable'
import RegisterEquipment from '../pages/ClientPanel/Equipment/Machines/RegisterEquipment'
import EditEquipment from '../pages/ClientPanel/Equipment/Machines/EditEquipment'
import VehicleTable from '../pages/ClientPanel/Equipment/Vehicles/VehicleTable'
import ViewOPCard from '../components/Modals/ViewPCP'
import RouterTable from '../pages/ClientPanel/router/routerTable'
import RouterSection from '../pages/ClientPanel/router'
import RouterContent from '../pages/ClientPanel/router/index2'
import FreightTable from '../pages/ClientPanel/router/freightTable'
import DateAndTimeTable from '../pages/ClientPanel/router/dateAndTimeTable'
import NewRouter from '../pages/ClientPanel/router/newRouter'
import FreightContent from '../components/routerModal/freightContent'
import VehicleContent from '../components/routerModal/vehicleContent'
import VehicleForm from '../components/routerModal/vehicleContent/vehicleForm'
import VehicleDetail from '../components/routerModal/vehicleContent/vehicleDetail'
import FreightForm from '../components/routerModal/freightContent/freightForm'
import FreightDetail from '../components/routerModal/freightContent/freightDetail'
import RouterDetail from '../components/routerModal/routerContent/routerDetail'
import FashionContent from '../pages/ClientPanel/FashionOrders'
import FashionOrdersTable from '../pages/ClientPanel/FashionOrders/FashionOrdersTable'
import AddFashionOrder from '../pages/ClientPanel/FashionOrders/RegisterFashionOrder'
import PreProgramming from '../pages/ClientPanel/FashionOrders/PreProgramming'
import ProductionFashionContent from '../pages/ClientPanel/ProductionFashion'
import ProductionFashionTable from '../pages/ClientPanel/ProductionFashion/ProductionTable'
import FashionProductionMovementTable from '../pages/ClientPanel/ProductionFashion/MovementTable'
import StartFashionProduction from '../pages/ClientPanel/ProductionFashion/StartFashionProduction'
import PCPDashboard from '../pages/ClientPanel/ProductionFashion/PCPDashboard'
import AddFashionOP from '../pages/ClientPanel/ProductionFashion/AddFashionOP'
import ServicesContent from '../pages/ClientPanel/Services'
import ResourcesContent from '../pages/ClientPanel/Resources'
import CreateResourceModal from '../components/Modals/Resource/CreateResource'
import StageServicesTable from '../pages/ClientPanel/Services/ServicesTable'
import ResourcesTable from '../pages/ClientPanel/Resources/ResourcesTable'
import CreateServiceModal from '../components/Modals/ServiceStage/CreateServiceModal'
import ViewServiceStageModal from '../components/Modals/ServiceStage/ViewServiceStageModal'
import ViewResourceModal from '../components/Modals/Resource/ViewResource'
import ExportStockModal from '../components/exportStockModal'
import AddCompanyModal from '../components/AddCompanyModal'
import TableCompanies from '../pages/ClientPanel/Companies/CompaniesTable'
import ProductFinal from '../pages/ClientPanel/ProductFinal'
import AddProductFinal from '../pages/ClientPanel/ProductFinal/AddProduct'
import ProductFinalTable from '../pages/ClientPanel/ProductFinal/ProductTable'
import ViewProductFinal from '../pages/ClientPanel/ProductFinal/ViewProduct'
import FamiliesLayout from '../pages/ClientPanel/Families'
import FamiliesTable from '../pages/ClientPanel/Families/FamiliesTable'
import ProductFinals from '../pages/ClientPanel/ProductFinal'
import SteelOrders from '../pages/ClientPanel/SteelOrders'
import AddOrder from '../pages/ClientPanel/SteelOrders/AddOrder'
import SteelOrdersTable from '../pages/ClientPanel/SteelOrders/SteelOrdersTable'
import ViewSteelOrder from '../pages/ClientPanel/SteelOrders/ViewSteelOrder'
import Tracking from '../pages/ClientPanel/SteelOrders/ViewSteelOrder/TrackingOrderTable/tracking'
import Orders from '../pages/ClientPanel/Orders'
import { TableFiltersProvider } from '../contexts/TableFiltersContext'
import PipelineContent from '../pages/ClientPanel/Pipelines'
import Kanban from '../pages/ClientPanel/Pipelines/kanban'
import ViewOrEditTicket from '../components/Pipelines/Modals/ViewOrEditTicket'
import ServicesTable2 from '../pages/ClientPanel/ProductionFlow/ServicesTable/index2'
import CreateOP from '../pages/ClientPanel/ProductionFlow/CreateOP'
import MagicLogin from '../pages/Login/MagicLogin/index'
import DocsIndex from '../pages/Docs'
import DocViewer from '../pages/Docs/DocViewer'
import UserContext from '../contexts/UserContext'
import GenerateInspectionFormModal from '../components/Modals/ViewPCP/GenerateInspectionForm'
import CollectionsContent from '../pages/ClientPanel/Collections'
import CollectionsTable from '../pages/ClientPanel/Collections/CollectionsTable'
import RegisterCollection from '../pages/ClientPanel/Collections/RegisterCollection'
import ProductCompositionContent from '../pages/ClientPanel/ProductComposition'
import CompositionTable from '../pages/ClientPanel/ProductComposition/CompositionTable'
import RegisterComposition from '../pages/ClientPanel/ProductComposition/RegisterComposition'
import OccurrencesContent from '../pages/ClientPanel/Occurrences'
import OccurrencesTable from '../pages/ClientPanel/Occurrences/OccurencesTable'
import ProductDevelopmentContent from '../pages/ClientPanel/ProductDevelopment'
import { useTenant } from '../contexts/TenantContext'

const ClientPanelLayout = () => (
  <PrivateRoute>
    <TableFiltersProvider>
      <ClientPanel />
    </TableFiltersProvider>
  </PrivateRoute>
)


const TenantTrackingGuard = () => {
  const { user } = useContext(UserContext);
  const { tenantId } = useTenant();
  const location = useLocation();
  const context = useOutletContext();

  const isTenantClient = (user?.role as string) === 'TENANT_CLIENT';
  const isAcoTenant = tenantId !== 2;

  console.log('🧭 [TENANT-TRACKING-GUARD] Snapshot', {
    pathname: location.pathname,
    userRole: user?.role,
    userId: user?.id || user?.sub,
    tenantId,
    isTenantClient,
    isAcoTenant,
    willRedirectToTracking: isTenantClient && isAcoTenant && location.pathname === '/panel',
  })

  if (isTenantClient && isAcoTenant && location.pathname === '/panel') {
    console.warn('🧭 [TENANT-TRACKING-GUARD] Redirecionando para /panel/steel/tracking', {
      pathname: location.pathname,
      tenantId,
      userRole: user?.role,
    })
    return <Navigate to="/panel/steel/tracking" replace />;
  }

  return <Outlet context={context} />;
};

const Router = () => {
  return (
    <BrowserRouter basename='/'>
      <Routes>
        {/** Rotas Públicas */}
        <Route path='/' element={<LoginScreen />} />
        <Route path='/login' element={<LoginScreen />} />
        <Route path='/magic-login' element={<MagicLogin />} />
        <Route path='/accessvalidation' element={<Validation />} />
        <Route path='/pendingmessage' element={<SuccessMsg />} />
        <Route path='/completeRegister' element={<CompleteRegister />} />
        <Route path='/internalaccess/:token' element={<AdminRegister />} />

        {/** Rotas Privadas dentro do ClientPanel */}
        <Route path='*' element={<NotFoundPage />} />
        <Route path='/panel' element={<ClientPanelLayout />}>
          <Route path='*' element={<NotFoundPage />} />

          <Route element={<TenantTrackingGuard />}>
            <Route index element={<HomeScreen />} />
            <Route
              path='certificates'
              element={
                <PermissionGuard
                  permission='certificates'
                  dependencies={['stock']}
                >
                  <CertificatesContent />
                </PermissionGuard>
              }
            >
              <Route index element={<CertificatesTable />} />
              <Route path='view/:id' element={<ViewCertificateModal />} />
              <Route path='create' element={<CreateCertificate />} />
              <Route path='edit' element={<CreateCertificate />} />
              <Route path='params' element={<ParamTable />} />
              <Route path='params/create' element={<CreateParam />} />
              <Route path='params/edit' element={<CreateParam />} />
            </Route>
            <Route
              path='stock'
              element={
                <PermissionGuard permission='stock'>
                  <StockContent />
                </PermissionGuard>
              }
            >
              <Route index element={<StockTable />} />
              <Route path='movement' element={<MovementTable />} />
              <Route path='export' element={<ExportStockModal />} />
              <Route path='resource' element={<Outlet />}>
                <Route index element={<ResourcesTable />} />
                <Route path='create' element={<CreateResourceModal />} />
                <Route path='edit' element={<CreateResourceModal />} />
                <Route path='view' element={<ViewResourceModal />} />
              </Route>
            </Route>
            <Route
              path='product-final'
              element={
                <PermissionGuard permission='products'>
                  <ProductFinals />
                </PermissionGuard>
              }
            >
              <Route index element={<ProductFinalTable />} />
              <Route path=':productId' element={<ViewProductFinal />} />
              <Route path='create' element={<AddProductFinal />} />
              <Route path='edit/:productId' element={<AddProductFinal />} />
            </Route>
            <Route path='production' element={
              <PermissionGuard permission="production" dependencies={['stock', 'orders']}>
                <ProductionFlow />
              </PermissionGuard>
            }>
              <Route index element={<ServicesTable2 />} />
              <Route path='movement' element={<ProductionMovementTable />} />
              <Route path='2' element={<ServicesTable />} />
              <Route path='create' element={<CreateOP />} />
              <Route path='edit/:id' element={<CreateOP />} />
              <Route path='2/card' element={<ViewOPCard />} />
              <Route path='services/card' element={<ViewOPCard />} />
              <Route path='pcp/:stageId' element={<AddOpInPcp />} />
              <Route path='services/create' element={<CreateOPModal />} />
              <Route path='stages' element={<StagesTable />} />

            </Route>
            <Route
              path='fashion'
              element={
                <TenantGuard requiredTenant='fashion'>
                  <PermissionGuard permission='orders'>
                    <FashionContent />
                  </PermissionGuard>
                </TenantGuard>
              }
            >
              <Route index element={<FashionOrdersTable />} />
              <Route path='pre-programming' element={<PreProgramming />} />
              <Route path='create' element={<AddFashionOrder />} />
              <Route path='edit/:orderId' element={<AddFashionOrder />} />
            </Route>
            <Route
              path='production-fashion'
              element={
                <TenantGuard requiredTenant='fashion'>
                  <PermissionGuard
                    permission='production'
                    dependencies={['stock', 'orders']}
                  >
                    <ProductionFashionContent />
                  </PermissionGuard>
                </TenantGuard>
              }
            >
              <Route index element={<ProductionFashionTable />} />
              <Route path='movement' element={<FashionProductionMovementTable />} />
              <Route path='start/:orderId' element={<StartFashionProduction />} />
              <Route path='pcp' element={<PCPDashboard />}>
                <Route path='create' element={<AddFashionOP />} />
              </Route>
            </Route>
            <Route
              path='people'
              element={
                <PermissionGuard permission='accesses'>
                  <PeopleContent />
                </PermissionGuard>
              }
            >
              <Route index element={<PeopleTableSwitch />} />
              <Route path='profiles' element={<TableProfile />} />
            </Route>
            <Route
              path='steel'
              element={
                <TenantGuard requiredTenant='Aco'>
                  <SteelOrders />
                </TenantGuard>
              }
            >
              <Route index element={<SteelOrdersTable />} />
              <Route path='tracking' element={<Tracking />} />
              <Route path=':orderId' element={<ViewSteelOrder />} />
              <Route path='create' element={<AddOrder />} />
              <Route path='edit/:orderId' element={<AddOrder />} />
            </Route>
            <Route path='companies' element={<CompaniesContent />}>
              <Route path='create' element={<AddCompanyModal />} />
              <Route path='edit' element={<AddCompanyModal />} />
            </Route>
            <Route
              path='service'
              element={
                <PermissionGuard permission='services'>
                  <ServicesContent />
                </PermissionGuard>
              }
            >
              <Route index element={<StageServicesTable />} />
              <Route path='create' element={<CreateServiceModal />} />
              <Route path='edit' element={<CreateServiceModal />} />
              <Route path='view' element={<ViewServiceStageModal />} />
            </Route>
            <Route
              path='resource'
              element={
                <PermissionGuard permission='resources'>
                  <ResourcesContent />
                </PermissionGuard>
              }
            >
              <Route index element={<ResourcesTable />} />
              <Route path='create' element={<CreateResourceModal />} />
              <Route path='edit' element={<CreateResourceModal />} />
              <Route path='view' element={<ViewResourceModal />} />
            </Route>
            <Route path='mach' element={<MachinesTable />} />
            <Route
              path='router'
              element={
                <TenantGuard requiredTenant={['Aco', 'fashion']}>
                  <PermissionGuard permission='router'>
                    <RouterContent />
                  </PermissionGuard>
                </TenantGuard>
              }
            >
              <Route index element={<FreightTable />} />
              <Route path='create' element={<FreightForm />} />
              <Route path=':freightId' element={<FreightDetail />} />
              <Route path='routers' element={<RouterTable />} />
              <Route path='dateAndTime' element={<DateAndTimeTable />} />
              <Route path='routers/create' element={<NewRouter />} />
              <Route path='routers/:routerId' element={<RouterDetail />} />
              <Route path='routers/edit' element={<NewRouter />} />
            </Route>
            <Route
              path='equipment'
              element={
                <PermissionGuard permission='equipment'>
                  <EquipmentContent />
                </PermissionGuard>
              }
            >
              <Route index element={<EquipmentTable />} />
              <Route path='register' element={<RegisterEquipment />} />
              <Route path='edit/:id' element={<EditEquipment />} />
              <Route path='vehicles' element={<VehicleTable />} />
            </Route>
            <Route
              path='product-development'
              element={
                <TenantGuard requiredTenant='fashion'>
                  <Navigate to='/panel/collection' replace />
                </TenantGuard>
              }
            />
            <Route
              element={
                <TenantGuard requiredTenant='fashion'>
                  <ProductDevelopmentContent />
                </TenantGuard>
              }
            >
              <Route path='collection' element={<CollectionsContent />}>
                <Route index element={<CollectionsTable />} />
                <Route path='register' element={<RegisterCollection />} />
                <Route path='edit/:id' element={<RegisterCollection />} />
              </Route>
              <Route path='families' element={<FamiliesLayout />}>
                <Route index element={<FamiliesTable />} />
              </Route>
              <Route path='composition-product' element={<ProductCompositionContent />}>
                <Route index element={<CompositionTable />} />
                <Route path='create' element={<RegisterComposition />} />
                <Route path='edit/:productId' element={<RegisterComposition />} />
              </Route>
            </Route>
            <Route
              path='orders'
              element={
                <PermissionGuard permission='orders'>
                  <Orders />
                </PermissionGuard>
              }
            />
            <Route path='pipeline' element={<PipelineContent />}>
              <Route index element={<Kanban />} />
              <Route path='ticket' element={<ViewOrEditTicket />} />
            </Route>
            <Route path='occurrences' element={<OccurrencesContent />}>
              <Route index element={<OccurrencesTable />} />
            </Route>
            <Route path='docs' element={
              <AdminGuard>
                <DocsIndex />
              </AdminGuard>
            } />
            <Route path='docs/:docId' element={
              <AdminGuard>
                <DocViewer />
              </AdminGuard>
            } />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export default Router
